import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import styles from "../../components/globalstyles";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useLogos from "../../hooks/useLogos";
import useApi from "../../hooks/useApi";

const Message = () => {
  const navigate = useNavigate();
  const { logo: logoBarra, logoClaro } = useLogos();
  const query = new URLSearchParams(useLocation().search);
  const directIntent = query.get("intent");
  const emailSent = query.get("email_sent") !== "0";
  const directOrder = query.get("direct_order") === "1";
  const { loadApi, loadingApi } = useApi();
  const [directEmail, setDirectEmail] = useState("");
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");

  const isDirectVerification =
    Boolean(directIntent) &&
    ["verify_email", "email_verified"].includes(query.get("type"));

  const continuarA = isDirectVerification
    ? `/login?intent=${encodeURIComponent(directIntent)}`
    : "/";

  const continuarTexto =
    query.get("type") === "email_verified" && directIntent
      ? "Entrar y ver mi pedido"
      : query.get("type") === "verify_email" && directOrder && directIntent
      ? "Ya verifiqué mi correo"
      : "Continuar";

  const permitidos = [
    "email_verified",
    "verify_email",
    "password_recovery",
    "reset_password",
  ];

  useEffect(() => {
    if (!permitidos.includes(query.get("type"))) {
      navigate("/");
      return;
    }

    if (directIntent) {
      loadApi(
        `general/direct-links/intent/${encodeURIComponent(directIntent)}`,
        false,
        "get"
      )
        .then(({ data }) => setDirectEmail(data.email || ""))
        .catch(() => {});
    }
  }, []);

  const reenviarVerificacion = async () => {
    if (!directEmail || !directIntent) return;
    setNotice("");
    setError("");
    try {
      const { data } = await loadApi(
        "resend_verification_code",
        false,
        "post",
        {
          username: directEmail,
          directIntent,
        }
      );
      setNotice(
        data.message ||
          "Si la cuenta está pendiente, reenviamos el correo de verificación."
      );
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <>
      {/* HEADER (SOLO MOVIL) */}
      <Box sx={styles.barramovil}>
        <img
          src={logoBarra}
          alt="Radar Freim"
          style={{ maxWidth: "180px", objectFit: "contain" }}
        />
      </Box>

      <Grid container sx={styles.root}>
        {/* VISTA IZQUIERDA */}
        <Grid item md={7} sx={styles.image}>
          <img
            alt="Radar Freim"
            src={logoClaro}
            style={{
              maxWidth: "40%",
              maxHeight: "140px",
              width: "auto",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Grid>
        {/* VISTA DERECHA */}
        <Grid container item md={5} px={4}>
          <Stack
            width="100%"
            spacing={2}
            px={3}
            justifyContent="center"
            alignItems="center"
          >
            <CheckCircleOutlineRoundedIcon
              sx={{ color: "green", height: "auto", width: "40%" }}
            />
            <Typography align="center">
              {query.get("type") === "email_verified" &&
                (directIntent
                  ? "¡Correo verificado! Tu pedido ya está en RadarFreim. Entra para verlo y darle seguimiento desde Mis envíos."
                  : "El correo se verificó correctamente!")}
              {query.get("type") === "password_recovery" &&
                "Por favor verifica tu bandeja de email, enviamos un enlace para recuperar tu contraseña!"}
              {query.get("type") === "reset_password" &&
                "Se restableció tu contraseña correctamente, Inicia sesión para continuar!"}
              {query.get("type") === "verify_email" &&
                (directOrder
                  ? emailSent
                    ? "¡Tu pedido ya fue enviado! Revisa tu correo para verificar tu cuenta de RadarFreim y poder darle seguimiento."
                    : "¡Tu pedido ya fue enviado y tu cuenta fue creada! No pudimos enviar el correo de verificación. Solicita uno nuevo desde RadarFreim para activar el acceso."
                  : "Registro exitoso! Por favor verifica tu bandeja de email para activar tu cuenta, si no encuentras el email, buscalo en spam.")}
            </Typography>
            {notice && (
              <Typography align="center" color="success.main">
                {notice}
              </Typography>
            )}
            {error && (
              <Typography align="center" color="error.main">
                {error}
              </Typography>
            )}

            {query.get("type") === "verify_email" &&
              directOrder &&
              directIntent && (
                <Button
                  variant="outlined"
                  disabled={!directEmail || loadingApi.includes("post__resend_verification_code")}
                  onClick={reenviarVerificacion}
                >
                  Reenviar correo de verificación
                </Button>
              )}

            <Button LinkComponent={Link} to={continuarA}>
              {continuarTexto}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default Message;
